import { useTranslation } from 'react-i18next';
import { SectionPanel } from '~/components/ui/SectionPanel';
import type { Currency, GetQuoteByIdQuery } from '~/graphql/graphql';
import type { ProductGroup } from '~/pages/rfq-view/itemGroups';
import { AcceptCounterQuoteAction } from '~/pages/rfq-view/sections/AcceptCounterQuoteAction';
import { CounterQuoteAction } from '~/pages/rfq-view/sections/CounterQuoteAction';
import { DeclineQuoteAction } from '~/pages/rfq-view/sections/DeclineQuoteAction';
import { QuoteConversation } from '~/pages/rfq-view/sections/QuoteConversation';
import { QuoteTimeline } from '~/pages/rfq-view/sections/QuoteTimeline';
import { sellerQuoteActions } from '~/pages/rfq-view/sections/quoteNegotiation';

type SellerQuote = NonNullable<GetQuoteByIdQuery['quote']>;

type SellerNegotiationPanelProps = Readonly<{
  quote: SellerQuote;
  groups: ProductGroup[];
  usesWholeRequestPrice: boolean;
  requestForQuoteCurrency: Currency | null | undefined;
}>;

export function SellerNegotiationPanel({
  quote,
  groups,
  usesWholeRequestPrice,
  requestForQuoteCurrency,
}: SellerNegotiationPanelProps) {
  const { t } = useTranslation('rfq-view');
  const actions = sellerQuoteActions(quote);

  return (
    <SectionPanel title={t('rfq_view.negotiation_heading')}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-start gap-2">
          {actions.acceptCounter && <AcceptCounterQuoteAction quote={quote} />}
          {actions.counter && (
            <CounterQuoteAction
              quote={quote}
              groups={groups}
              usesWholeRequestPrice={usesWholeRequestPrice}
              requestForQuoteCurrency={requestForQuoteCurrency}
            />
          )}
          {actions.decline && <DeclineQuoteAction quote={quote} />}
        </div>
        <QuoteTimeline quoteId={quote.id} rounds={quote.rounds} />
        <QuoteConversation quoteId={quote.id} canComment={actions.comment} />
      </div>
    </SectionPanel>
  );
}
